// APN Membership tiers configuration
export const MEMBERSHIP_TIERS = {
  TIER1: {
    id: 'tier1',
    name: 'Tier 1',
    price: 75,
    priceId: 'price_tier1_annual', // Stripe price ID
    description: 'Analysts & Associates with less than three years of experience (also referred to as recent undergraduates).',
    features: [
      'Access to member directory',
      'Job board access',
      'Project board access',
      'Networking events',
      'Professional groups'
    ],
    duration: 'annual'
  },
  TIER2: {
    id: 'tier2',
    name: 'Tier 2',
    price: 125,
    priceId: 'price_tier2_annual',
    description: 'Analysts & Associates with more than three years of experience.',
    features: [
      'All Tier 1 benefits',
      'Priority event registration',
      'Enhanced profile visibility',
      'Advanced networking tools',
      'Mentorship opportunities'
    ],
    duration: 'annual'
  },
  TIER3: {
    id: 'tier3',
    name: 'Tier 3',
    price: 175,
    priceId: 'price_tier3_annual',
    description: 'Managers, VP\'s, Directors, and Managing Directors.',
    features: [
      'All Tier 2 benefits',
      'Executive networking events',
      'Industry insights access',
      'Leadership development',
      'Strategic partnership opportunities'
    ],
    duration: 'annual'
  },
  TIER4: {
    id: 'tier4',
    name: 'Tier 4',
    price: 225,
    priceId: 'price_tier4_annual',
    description: 'C-suite Executives, Principals, Partners, and Business Owners.',
    features: [
      'All Tier 3 benefits',
      'VIP event access',
      'Direct CEO networking',
      'Investment opportunities',
      'Board advisory access'
    ],
    duration: 'annual'
  },
  TIERUSV: {
    id: 'tierUSV',
    name: 'Tier USV',
    price: 75,
    priceId: 'price_tierUSV_annual',
    description: 'US Veterans, regardless of seniority level.',
    features: [
      'All standard benefits',
      'Veteran networking group',
      'Career transition support',
      'Military-to-civilian mentorship',
      'Special veteran events'
    ],
    duration: 'annual'
  }
};

// Helper function to get tier by key
export const getTierByKey = (tierKey) => {
  return MEMBERSHIP_TIERS[tierKey.toUpperCase()];
};

// Helper function to get all tier keys
export const getAllTierKeys = () => {
  return Object.keys(MEMBERSHIP_TIERS);
};

// Helper function to get tier by ID
export const getTierById = (tierId) => {
  return Object.values(MEMBERSHIP_TIERS).find(tier => tier.id === tierId);
};
